import styled from 'styled-components'

import theme from '../../assets/theme'

export const Conteiner = styled.footer`
    background: ${theme.colors.primary};
    display: flex;
    flex-direction: row;
    justify-content: center;
`
